import { EmployeeEntity } from '../dave-data-module/entities/employee.entity';
import { EntityRoleEntity,EntityRoleSlugEnum,EntityTypesEnum } from '../dave-data-module/entities/entity-role.entity';
import { UserToCommissionEntity } from '../dave-data-module/entities/user-to-commission.entity';

const excludedRoleNames: string[] = [
    EntityRoleSlugEnum.Admin,
    EntityRoleSlugEnum.Projektleiter,
    EntityRoleSlugEnum.Kundenbetreuer,
    EntityRoleSlugEnum.Personalmanager,
    EntityRoleSlugEnum.Ressourcebetrachter,
    EntityRoleSlugEnum.Prozessbearbeiter,
    EntityRoleSlugEnum.Prozessverantwortlicher,
    EntityRoleSlugEnum.Nutzer,
    // luksch
    EntityRoleSlugEnum.Kalkulation,
    EntityRoleSlugEnum.Projektierung,
];

/**
 * filtert die Mitarbeiter, für die auf einem Auftrag Zeiten erfasst werden können, die Reihenfolge von employees bleibt erhalten
 */
export function getTimeTrackableEmployeesFromCommission(commissionId: number | null, employees: EmployeeEntity[], entityRoles: EntityRoleEntity[], allUserToCommissions: UserToCommissionEntity[]): EmployeeEntity[] {
    if (!commissionId) {
        return [];
    }
    const excludeRoleIds = entityRoles.filter((r) => r.Entity === EntityTypesEnum.Commission && excludedRoleNames.includes(r.Name)).map((r) => r.Id);
    const userToCommissionByCommission = allUserToCommissions.filter((u2c) => u2c.CommissionId === commissionId);
    return employees.filter((e) => {
        if (!e.UserId) {
            return false;
        }
        const u2cByEmployee = userToCommissionByCommission.filter((u2c) => u2c.UserId === e.UserId);
        return u2cByEmployee.length > 0 && u2cByEmployee.some((u2c) => u2c.RoleId && !excludeRoleIds.includes(u2c.RoleId));
    });
}
